import styled, { css } from 'styled-components';
import { IconGlyph } from '@/app/common/icons/MaskIcon';
import { lbButton } from '../Listbox/styled';

export const SelectStyled = styled.div<{ disabled?: boolean }>`
  ${lbButton}
  height: 44px;
  line-height: 44px;
  display: flex;
  flex-direction: row;
  align-items: center;

  label {
    position: absolute;
    top: -21px;
    left: 0;
    display: block;
    font-size: 13px;
  }
  select {
    padding: 0px 26px 0px 0px;
    border: 0;
    background: transparent;
    height: 46px;
    color: #080808;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 100%;
    cursor: pointer;
    z-index: 1;
    outline: none;
    @media screen and (min-width: 560px) {
      height: 44px;
    }
  }
  ${IconGlyph} {
    pointer-events: none;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
    `}
`;
